import { render, staticRenderFns } from "./RegisterShipping.vue?vue&type=template&id=a80b0610"
import script from "./RegisterShipping.vue?vue&type=script&lang=js"
export * from "./RegisterShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports